import DeductionItem from './DeductionItem';

export default DeductionItem;